import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  CircularProgress,
  Pagination,
  Stack,
  Autocomplete,
  Grid,
  TextField,
  IconButton,
  InputLabel,
  Checkbox,
  Grid2,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";
import SimpleDialog from "../../components/Modal/index";
import { Controller, useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";

const statusOptions = ["End Journey", "Engine Failure", "Interchange"];

export default function LiveTrains() {
  const [liveTrains, setLiveTrains] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [stations, setStations] = useState([]);
  const [trains, setTrains] = useState([]);
  const [openInterChange, setOpenInterChange] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [selectedTrain, setSelectedTrain] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filteredLocomotives, setFilteredLocomotives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
   const [direction, setDirection] = useState("");
   const [checkbox, setCheckBox] = useState("");
  const [error, setError] = useState("");
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    reset,
    watch
  } = useForm();

  

  const handleDirectionChange = (event) => {
    setDirection(event.target.value);
    setError(""); // Clear the error on valid selection
  };
  const handleCheckboxChange = (event) => {
    // console.log(event.target.value)
    setCheckBox(event.target.checked);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage - 1);
  };

  const getTrains = async () => {
    try {
      const result = await AuthServices.getTrains();
      // console.log(result);
      if (result.IsSuccess == true) {
        setTrains(result?.Response);
        setFilteredLocomotives(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    getTrains();
  }, []);

  useEffect(() => {
    setValue("name", selectedTrain?.TrainName);
    setValue("trainNumber", selectedTrain?.TrainNumber);
    setValue("trainNameUr", selectedTrain?.TrainNameUR);
    setValue("trainDesc", selectedTrain?.TrainDescription);
    setCheckBox(selectedTrain.IsLive == true ? true : false)
    setDirection(selectedTrain.IsUp == true ? true : false);
  }, [editDialog]);
  // console.log(selectedTrain);

  const onSubmit = async (formData) => {
    // console.log(formData)
    const obj = {
        IsLive:  checkbox,
        IsUp: direction == true ? true :false,
        TrainDescription: formData?.trainDesc,
        TrainId: selectedTrain?.TrainId,
        TrainName : formData?.name,
        TrainNameUR :  formData?.trainNameUr,
        TrainNumber :formData?.trainNumber,
        UpdatedBy :  1
    };
    try {
        const result = await AuthServices.updateTrainById(obj);
        // console.log(result);
        if (result.IsSuccess == true) {
         getTrains()
         setEditDialog(false)
        }
      } catch (error) {
        // console.log(error);
      }
  };
  const deleteTrain = async () => {
    try {
      const result = await AuthServices.deleteTrain(
        selectedTrain?.TrainId
      );
      // console.log(result);
      if (result.IsSuccess == true) {
        SuccessToaster("Deleted Successfully");
        getTrains();
        setDeleteDialog(false);
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = trains.filter(
      (locomotive) =>
        locomotive.LocomotiveNumber.toString().includes(value) ||
        locomotive.imie?.toLowerCase().includes(value) ||
        locomotive.MobileNumber?.toLowerCase().includes(value)
    );
    setFilteredLocomotives(filtered);
  };

  const handleChangeStatus = async(isLive , trainID)=>{
    const obj={
        IsLive: isLive,
        TrainId: trainID
    }
    try {
        const result = await AuthServices.updatetTrainStatus(
            obj
        );
        // console.log(result);
        if (result.IsSuccess == true) {
          SuccessToaster("Updated Successfully");
          getTrains();
        }
      } catch (error) {
        ErrorToaster("Something went Wrong");
      }
  }
  return (
    <>
      <Box sx={{ mb: 3 }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  color: Colors.primary,
                  fontWeight: 500,
                  letterSpacing: "1px",
                }}
              >
               TRAIN LIST
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                TRAIN /TRAIN LIST
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      <SimpleDialog
        open={editDialog}
        onClose={() => {
          setEditDialog(false);
        }}
        maxWidth={"md"}
        title="Edit Train "
      >
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid2 container spacing={2} sx={{ mb: 3 }}>
        {/* Name Field */}
        <Grid2  size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Name
          </Typography>
          <TextField
            fullWidth
            {...register("name", {
              required: "Name is Required",
            })}
            error={!!errors.name}
            helperText={errors.name ? errors.name.message : ""}
          />
        </Grid2>

        {/* Train Number Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Number
          </Typography>
          <TextField
            fullWidth
            {...register("trainNumber", { required: "Train Number is Required" })}
            error={!!errors.trainNumber}
            helperText={errors.trainNumber ? errors.trainNumber.message : ""}
          />
        </Grid2>

        {/* Train Name (Urdu) Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Name (Urdu)
          </Typography>
          <TextField
            fullWidth
            {...register("trainNameUr", {
              required: "Train Name (Urdu) is Required",
            })}
            error={!!errors.trainNameUr}
            helperText={errors.trainNameUr ? errors.trainNameUr.message : ""}
          />
        </Grid2>

        {/* Train Description Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Description
          </Typography>
          <TextField
            fullWidth
            {...register("trainDesc", {
              required: "Train Description is Required",
            })}
            error={!!errors.trainDesc}
            helperText={errors.trainDesc ? errors.trainDesc.message : ""}
          />
        </Grid2>
        <Grid2 size={{xs:12 ,md:4}}>
  <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
    Direction
  </Typography>
  <RadioGroup
        row
        value={direction}
        onChange={handleDirectionChange}
      >
        <FormControlLabel value="true" control={<Radio />} label="Up" />
        <FormControlLabel value="false" control={<Radio />} label="Down" />
      </RadioGroup>

  {/* {errors.direction && (
    <Typography color="error" variant="caption">
      {errors.direction.message}
    </Typography>
  )} */}
</Grid2>

        {/* IsLive Checkbox */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Is Live
          </Typography>
          <FormControlLabel
          control={
            <Checkbox
              checked={checkbox} // State controls the checked value
              onChange={handleCheckboxChange} // Update state on change
            />
          }
          label="is Live"
        />
        </Grid2>
      </Grid2>

      {/* Submit Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="submit"
          variant="contained"
          sx={{
            bgcolor: "darkgreen",
            "&:hover": {
              bgcolor: "green",
            },
          }}
        >
          Update
        </Button>
      </Box>
    </Box>
      </SimpleDialog>

      <SimpleDialog
        open={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Are you sure you want to Delete this Train?
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: 2,
            mt: 3,
          }}
        >
          <Button
            sx={{ background: "grey", color: "white", px: 2.5 }}
            onClick={() => setDeleteDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ background: "rgb(0, 100, 0)" }}
            onClick={deleteTrain}
          >
            Confirm
          </Button>
        </Box>
      </SimpleDialog>
      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          backgroundColor: Colors.white,
          borderRadius: "12px",
        }}
      >
        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white",textAlign:'center'}}>#</TableCell>
                <TableCell sx={{ color: "white",textAlign:'center' }}>
                  Train Name
                </TableCell>
                <TableCell sx={{ color: "white",textAlign:'center' }}>
                  Train Number
                </TableCell>
                <TableCell sx={{ color: "white",textAlign:'center' }}>
                  Train Description
                </TableCell>
                <TableCell sx={{ color: "white",textAlign:'center' }}>
                  Live/UnLive
                </TableCell>
                <TableCell sx={{ color: "white",textAlign:'center' }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                filteredLocomotives
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((train, index) => (
                    <TableRow key={train.LocomotiveId}>
                      <TableCell sx={{textAlign:"center"}}>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell sx={{textAlign:"center"}}>{train.TrainName}</TableCell>
                      <TableCell sx={{textAlign:"center"}}>{train.TrainNumber}</TableCell>
                      <TableCell sx={{textAlign:"center"}}>{train.TrainDescription}</TableCell>
                      <TableCell sx={{textAlign:"center"}}>
                        <Checkbox
                          checked={train.IsLive}
                          onChange={(event) => {
                            handleChangeStatus(event.target.checked,train?.TrainId);
                          }}
                        />
                      </TableCell>
                      <TableCell sx={{textAlign:"center"}}>
                        <IconButton
                          aria-label="edit"
                          onClick={() => {
                            setEditDialog(true);
                            setSelectedTrain(train);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setDeleteDialog(true);
                            setSelectedTrain(train);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <Pagination
            count={Math.ceil(filteredLocomotives.length / rowsPerPage)}
            page={page + 1}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderColor: "rgb(19, 62, 2)",
                color: "rgb(19, 62, 2)",
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                bgcolor: "rgb(19, 62, 2)",
                color: "white",
              },
            }}
          />
        </Stack>
      </Container>
    </>
  );
}
